import { CampaignsHubspot } from '../../components/organisms/Hubspot'
import { HomeTemplate } from '../../components/templates/homeTemplate'

export function CampaignsHubspotPage() {
	return (
		<HomeTemplate>
			<CampaignsHubspot />
		</HomeTemplate>
	)

	// <NotfoundPage />
}
